import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import VerifyResults from "@/pages/VerifyResults";
import DashboardLayout from "@/components/DashboardLayout";
import Dashboard from "@/pages/Dashboard";
import NewPatient from "@/pages/reception/NewPatient";
import CreateOrder from "@/pages/reception/CreateOrder";
import ResultsCapture from "@/pages/reception/ResultsCapture";
import EditRequest from "@/pages/reception/EditRequest";
import Quotation from "@/pages/reception/Quotation";
import WorkOrder from "@/pages/reception/WorkOrder";
import History from "@/pages/reception/History";
import PatientRecords from "@/pages/reception/PatientRecords";
import Studies from "@/pages/catalogs/Studies";
import Analytes from "@/pages/catalogs/Analytes";
import AnalyteFormulas from "@/pages/catalogs/AnalyteFormulas";
import Profiles from "@/pages/catalogs/Profiles";
import Areas from "@/pages/catalogs/Areas";
import Techniques from "@/pages/catalogs/Techniques";
import Methods from "@/pages/catalogs/Methods";
import SampleTypes from "@/pages/catalogs/SampleTypes";
import Containers from "@/pages/catalogs/Containers";
import Patients from "@/pages/catalogs/Patients";
import Doctors from "@/pages/catalogs/Doctors";
import Companies from "@/pages/catalogs/Companies";
import PriceLists from "@/pages/catalogs/PriceLists";
import StudiesReport from "@/pages/reports/StudiesReport";
import Arqueo from "@/pages/reports/Arqueo";
import AdminSettings from "@/pages/admin/Settings";
import AdminUsers from "@/pages/admin/Users";
import AdminBranches from "@/pages/admin/Branches";
import AdminRoles from "@/pages/admin/Roles";
import PrintFormat from "@/pages/admin/PrintFormat";
import ReceiptFormat from "@/pages/admin/ReceiptFormat";
import QuoteFormat from "@/pages/admin/QuoteFormat";
import LoginConfig from "@/pages/admin/LoginConfig";
import Backup from "@/pages/settings/Backup";
import QuotationPWA from "@/pages/pwa/QuotationPWA";
import "@/App.css";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/verificar/t/:token" element={<VerifyResults />} />
      <Route path="/verificar/:folio" element={<VerifyResults />} />
      <Route path="/cotizador" element={<QuotationPWA />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <DashboardLayout>
              <Routes>
                <Route index element={<Dashboard />} />
                <Route path="reception/new-patient" element={<NewPatient />} />
                <Route path="reception/create-order/:patientId" element={<CreateOrder />} />
                <Route path="reception/results" element={<ResultsCapture />} />
                <Route path="reception/edit-request" element={<EditRequest />} />
                <Route path="reception/quotation" element={<Quotation />} />
                <Route path="reception/work-order" element={<WorkOrder />} />
                <Route path="reception/history" element={<History />} />
                <Route path="reception/records" element={<PatientRecords />} />
                <Route path="catalogs/studies" element={<Studies />} />
                <Route path="catalogs/analytes" element={<Analytes />} />
                <Route path="catalogs/analyte-formulas" element={<AnalyteFormulas />} />
                <Route path="catalogs/profiles" element={<Profiles />} />
                <Route path="catalogs/areas" element={<Areas />} />
                <Route path="catalogs/techniques" element={<Techniques />} />
                <Route path="catalogs/methods" element={<Methods />} />
                <Route path="catalogs/sample-types" element={<SampleTypes />} />
                <Route path="catalogs/containers" element={<Containers />} />
                <Route path="catalogs/patients" element={<Patients />} />
                <Route path="catalogs/doctors" element={<Doctors />} />
                <Route path="catalogs/companies" element={<Companies />} />
                <Route path="catalogs/price-lists" element={<PriceLists />} />
                <Route path="reports/studies" element={<StudiesReport />} />
                <Route path="reports/arqueo" element={<Arqueo />} />
                <Route path="admin/settings" element={<AdminSettings />} />
                <Route path="admin/login-config" element={<LoginConfig />} />
                <Route path="admin/users" element={<AdminUsers />} />
                <Route path="admin/branches" element={<AdminBranches />} />
                <Route path="admin/roles" element={<AdminRoles />} />
                <Route path="admin/print-format" element={<PrintFormat />} />
                <Route path="admin/receipt-format" element={<ReceiptFormat />} />
                <Route path="admin/quote-format" element={<QuoteFormat />} />
                <Route path="admin/backup" element={<Backup />} />
                <Route path="settings/backup" element={<Backup />} />
              </Routes>
            </DashboardLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="bottom-left" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
